import { ReactNode } from 'react'

export interface Props {
  data: {
    head: {
      title: string
      className?: string
    }[]
    body: {
      value: ReactNode
    }[][]
  }
  type?: 'horizontal' | 'vertical'
}

export const useTable = (props: Props) => {
  const { data, type } = props

  return {
    data,
    type,
  }
}
